import { createSelector } from "@reduxjs/toolkit";
import { AuthenticatedStore } from "./authenticated.store";
//#region Root selectors
const getAuthenticatedFeature = (state) => state[AuthenticatedStore.featureKey];
export const getAuthenticated = createSelector(getAuthenticatedFeature, (authenticated) => authenticated);
export const getIsLoggedIn = createSelector(getAuthenticated, (authenticated) => { var _a; return Boolean(!authenticated || (authenticated && ((_a = authenticated.auth) === null || _a === void 0 ? void 0 : _a.user))); });
